import React, { Component } from "react";
import axios from "axios";
import config from "react-global-configuration";
import { Card, Label, Input, Button, FormGroup, Row, Col } from "reactstrap";
import CommonNavbar from "./commonNavbar";
import "react-datepicker/dist/react-datepicker.css";

class AdminCreateNewBankSchemes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      issuerBanks: [],
      tenures: [],
      manufacturers: [],
      selectedBank: "",
      selectedTenure: "",
      selectedManufacturer: "",
      updatedRoi: "",
      updatedEffectiveRoi: "",
      scheduleDateTime: new Date(),
      selectedOption: "",
    };
  }

  componentDidMount() {
    this.fetchIssuerBanks();
    this.fetchTenures();
    this.fetchManufacturers();
  }

  // Fetch Issuer Banks
  fetchIssuerBanks = async () => {
    const token = localStorage.usertoken;
    try {
      const response = await axios.get(`${config.get("API_URL")}/brandemi/findAllIssuerBanks`, {
        headers: {
        Authorization: ` ${token}`
      }
      });
      this.setState({ issuerBanks: response.data._embedded.issuerBanks });
    } catch (error) {
      console.error("Error fetching issuer banks:", error);
    }
  };

  // Fetch Tenures
  fetchTenures = async () => {
    const token = localStorage.usertoken;
    try {
      const response = await axios.get(`${config.get("API_URL")}/brandemi/findAllTenures`, {
        headers: {
          Authorization: ` ${token}`
        }
      });

      // Filter out the tenure with innoTenureCode "XXXXX"
      const filteredTenures = response.data._embedded.tenures.filter(
        (tenure) => tenure.innoTenureCode !== "XXXXX"
      );

      this.setState({ tenures: filteredTenures });

    } catch (error) {
      console.error("Error fetching tenures:", error);
    }
  };


  // Fetch Manufacturers
  fetchManufacturers = async () => {
    const token = localStorage.usertoken;
    try {
      const response = await axios.get(`${config.get("API_URL")}/brandemi/findAllManufacturers`, {
        headers: {
        Authorization: ` ${token}`
      }
      });
      this.setState({ manufacturers: response.data });
    } catch (error) {
      console.error("Error fetching manufacturers:", error);
    }
  };

  // Handle Input Change
  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // Handle Form Submission
  handleSubmit = async () => {
    const {
      selectedBank,
      selectedTenure,
      selectedManufacturer,
      updatedRoi,
      updatedEffectiveRoi,
    } = this.state;

    // Validation
    if (!selectedBank || !selectedTenure || !updatedRoi || !updatedEffectiveRoi) {
      alert("Please fill all fields before submitting.");
      return;
    }

    if (updatedRoi <= 0 || updatedEffectiveRoi <= 0) {
      alert("ROI or E-ROI cannot be zero or negative");
      return;
    }

    const confirmUpdate = window.confirm(
      `Are you sure you want to create a new Bank Scheme with ROI ${updatedRoi}?`
    );
    if (!confirmUpdate) return;

    const payload = {
      bank_code: selectedBank,
      tenure_code: selectedTenure,
      manufacturer_code: selectedManufacturer,
      roi: parseFloat(updatedRoi),
      eroi: parseFloat(updatedEffectiveRoi),
    };

    try {
      const response = await axios.post(`${config.get("API_URL")}/brandemi/create-bank-scheme`, payload, {
        headers: { Authorization: ` ${localStorage.usertoken}` },
      });

      alert(response.data.message || "Bank scheme created successfully!");
      this.resetForm();
    } catch (error) {
      console.error("Error creating bank scheme:", error);
      alert("Failed to create bank scheme.Duplicate entry!!!");
    }
  };

  // Reset Form After Submit
  resetForm = () => {
    this.setState({
      selectedBank: "",
      selectedTenure: "",
      selectedManufacturer: "",
      updatedRoi: "",
      updatedEffectiveRoi: ""
    });
  };

  // Handle Go Back
  goBack = () => {
    this.props.history.goBack();
  };

  render() {
    const {
      issuerBanks,
      tenures,
      manufacturers,
      selectedBank,
      selectedTenure,
      selectedManufacturer,
      updatedRoi,
      updatedEffectiveRoi,
    } = this.state;

    return (
      <div className="content longcontent">
        <CommonNavbar />
        <div className="container-fluid">
          <Card>
            <div className="header">
              <h4 className="title">Create New Bank Scheme</h4>
              <Button color="primary" className="btn-capitalize pull-right" onClick={this.goBack}>
                Go Back
              </Button>
            </div>

            <div className="content">
              <Row className="top-margin-10">
                {/* Issuer Bank Dropdown */}
                <Col md={4}>
                  <Label>Issuer Bank*</Label>
                  <Input
                      type="select"
                      name="selectedBank"
                      value={selectedBank}
                      onChange={this.handleInputChange}
                  >
                    <option value="">Select Bank</option>
                    {issuerBanks.map((bank) => (
                        <option key={bank.innoIssuerBankCode} value={bank.innoIssuerBankCode}>
                          {bank.issuerBankDisplayName}
                        </option>
                    ))}
                  </Input>
                </Col>

                {/* Tenure Dropdown */}
                <Col md={4}>
                  <Label>Tenure*</Label>
                  <Input
                      type="select"
                      name="selectedTenure"
                      value={selectedTenure}
                      onChange={this.handleInputChange}
                  >
                    <option value="">Select Tenure</option>
                    {tenures.map((tenure) => (
                        <option key={tenure.innoTenureCode} value={tenure.innoTenureCode}>
                          {tenure.tenureDisplayName}
                        </option>
                    ))}
                  </Input>
                </Col>

                {/* Manufacturer Dropdown */}
                <Col md={4}>
                  <Label>Manufacturer</Label>
                  <Input
                      type="select"
                      name="selectedManufacturer"
                      value={selectedManufacturer}
                      onChange={this.handleInputChange}
                  >
                    <option value="">Select Manufacturer</option>
                    {manufacturers.map((manufacturer) => (
                        <option key={manufacturer.id} value={manufacturer.id}>
                          {manufacturer.party_name}
                        </option>
                    ))}
                  </Input>
                </Col>
              </Row>

              {/* ROI and Effective ROI */}
              <Row className="top-margin-10">
                <Col md={6}>
                  <Label>ROI*</Label>
                  <Input
                      type="number"
                      name="updatedRoi"
                      value={updatedRoi}
                      onChange={this.handleInputChange}
                  />
                </Col>

                <Col md={6}>
                  <Label>Effective ROI*</Label>
                  <Input
                      type="number"
                      name="updatedEffectiveRoi"
                      value={updatedEffectiveRoi}
                      onChange={this.handleInputChange}
                  />
                </Col>
              </Row>

              {/* Submit Button */}
              <div className="row top-margin-10">
                <div className="col-md-12">
                  <button onClick={this.handleSubmit} className="btn btn-primary btn-capitalize pull-left">Submit
                  </button>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    );
  }
}

export default AdminCreateNewBankSchemes;
